import React, { FC, ReactElement } from 'react';
import { formatNumber } from 'humanize-plus';
import moment from 'moment';

import { Maybe } from 'interfaces/graphql-typings';
export type TargetPrice = { createdAt: Maybe<string>; priceTarget: number };

import styles from './pricingDetailsStyles.scss';

const PriceTargetOverlay: FC<{
  targetPriceList: TargetPrice[];
  currencyCode: string;
}> = ({ targetPriceList, currencyCode }): ReactElement => (
  <div className={styles.priceTargetTooltipArea}>
    <div className={styles.priceTargetHeader}>Price Target Update History</div>
    {targetPriceList.map(
      (data, idx): ReactElement => (
        <div key={idx} className={styles.priceTargetItem}>
          <div className={styles.priceTargetItemLeft}>
            {moment(data.createdAt).format('M/D/YY')}
          </div>
          <div className={styles.priceTargetItemMiddle} />
          <div className={styles.priceTargetItemRight}>
            <strong>
              {formatNumber(data.priceTarget, 2)} {currencyCode}
            </strong>
          </div>
        </div>
      )
    )}
  </div>
);

export default PriceTargetOverlay;
